import { SET_ALERT, SET_ALERT_CONTEXT, SET_ALERT_SEVERITY, CLEAR_ALERT, AlertActions } from "../actions/alerts-actions";
import { AlertColor } from '@mui/material/Alert';

export interface AlertStateProps {
    alert?: boolean ;
    alertSeverity?: AlertColor ;
    alertContext?: string ;
} 

const initialState: AlertStateProps = {
    alert : false,
    alertSeverity: 'info',
    alertContext: '',
};

const alertsReducer = (state: AlertStateProps = initialState, action:AlertActions): AlertStateProps=>{
    switch (action.type) {
        case SET_ALERT:
        return {
            ...state, alert: action.payload,
        }

        case SET_ALERT_SEVERITY: 
        return {
            ...state, alertSeverity: action.payload,
        }

        case SET_ALERT_CONTEXT: 
        return {
            ...state, alertContext: action.payload,
        }

        case CLEAR_ALERT: 
        return {
            ...state, 
            alert: false,
            alertSeverity: 'info',
            alertContext: "",
        }
        default: 
        return state
    }
}

export { alertsReducer };
